<template>
  <el-dialog
    :visible="visible"
    :title="detail ? '编辑违约金' : '新增违约金'"
    width="70%"
    @close="$emit('update:visible', false)"
  >
    <SiruiSearch
      ref="formRef"
      :query="query"
      :columns="addFormColumns"
      :rules="formRules"
      :isQueryPanel="false"
      @changeMethod="changeMethod"
    />
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible', false)">取 消</el-button>
      <el-button type="primary" @click="submitHandle">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { addFormColumns, formRules } from './index.js';
  export default {
    name: 'liquidateDamagesAddDialog',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      detail: {
        type: Object || null,
        default: null,
      },
    },
    data() {
      return {
        formRules,
        query: {
          // 平台公司
          platformCompanyCode: null,
          platformCompanyName: null,
          // 业务公司
          contractBusinessCompanyNo: null,
          contractBusinessCompanyName: null,
          // 业务部门
          contractBusinessDepartmentNo: null,
          contractBusinessDepartmentName: null,
          contractNo: null, // 合同号
          contractName: null,
          contractCategory: 'sales', // 合同类型 purchase采购,sales销售
          projectInitiationNo: null, // 立项编号
          projectName: null, // 立项名称
          customerNo: null, // 客户编号
          customerName: null, // 客户名称
          settlementDate: null, // 结算日类型 (0-开票日期,1-发货日期
          // settlementDateName: null, // 结算日期
          invoiceDate: null, // 开票日期
          deliveryDate: null, // 发货日期
          returnedDate: null, // 下游应付款日期
          actualCollectionDate: null, // 下游实际回款日期
          allocationAmount: null, // 下游实际回款金额
          invoiceAmount: null, // 开票金额
          rate: null, // 比例 默认100%
          isManual: true, // 手动
          accumulateOverdueAmount: null, // 下游实际累计逾期金额
          remainUnpaidAmount: null, // 剩余应付未付金额
          overdueDays: null, // 逾期周期(天)
          overdueFlag: '1', //是否逾期
          liquidatedDamagesType: null, // 合同违约金类型 (按固定值 按利率)
          liquidatedInterestRateThousand: null, // 违约金日利率 (单位：%)
          liquidatedAmountFixed: null, // 违约金固定值
          liquidatedAmountDailyRate: null, // 违约金固定值
          liquidatedAmountOther: null, // 其他类型违约金
        },
        departmentList: [],
      };
    },
    computed: {
      addFormColumns() {
        return addFormColumns(this);
      },
    },
    watch: {
      detail: {
        handler(val) {
          if (val) {
            this.setDetailData(val);
          }
        },
        immediate: true,
      },
    },
    methods: {
      setDetailData(data) {
        let detail = {};
        if (data.invoiceInfo) {
          detail = Object.assign({}, data, data.invoiceInfo);
          delete detail.invoiceInfo;
        } else {
          detail = Object.assign({}, data);
        }
        if (detail.liquidatedAmountDailyRate) {
          detail.liquidatedDamagesType = 'RATE';
        } else if (detail.liquidatedAmountFixed) {
          detail.liquidatedDamagesType = 'FIXED';
        } else if (detail.liquidatedAmountOther) {
          detail.liquidatedDamagesType = 'OTHER';
        }
        detail.rate = (detail.rate || '').replace('%', '');
        Object.assign(this.query, detail);
      },
      formatData(data) {
        let invoiceInfo = {
          contractNo: data.contractNo, // 合同号
          contractName: data.contractName, // 合同号
          invoiceDate: data.invoiceDate, // 开票日期
          deliveryDate: data.deliveryDate, // 发货日期
          returnedDate: data.returnedDate, // 下游应付款日期
          actualCollectionDate: data.actualCollectionDate, // 下游实际回款日期
          allocationAmount: data.allocationAmount, // 下游实际回款金额
          invoiceAmount: data.invoiceAmount, // 开票金额
          rate: data.rate, // 比例 默认100%
          accumulateOverdueAmount: data.accumulateOverdueAmount, // 下游实际累计逾期金额
          remainUnpaidAmount: data.remainUnpaidAmount, // 剩余应付未付金额
          overdueDays: data.overdueDays, // 逾期周期(天)
          overdueFlag: '1', //是否逾期
          liquidatedDamagesType: data.liquidatedDamagesType, // 合同违约金类型 (按固定值 按利率)
          liquidatedInterestRateThousand: data.liquidatedInterestRateThousand, // 违约金日利率 (单位：%)
          liquidatedAmountFixed: data.liquidatedAmountFixed, // 违约金固定值
          liquidatedAmountOther: data.liquidatedAmountOther, // 其他类型违约金
        };
        const params = { ...data, invoiceInfoList: [invoiceInfo] };
        delete params.invoiceDate;
        delete params.deliveryDate;
        delete params.returnedDate;
        delete params.actualCollectionDate;
        delete params.allocationAmount;
        delete params.rate;
        delete params.accumulateOverdueAmount;
        delete params.remainUnpaidAmount;
        params.overduePeriod = data.overdueDays;
        delete params.overdueDays;
        delete params.liquidatedInterestRate;
        delete params.liquidatedAmountFixed;
        delete params.liquidatedAmountOther;
        // delete params.id;
        return params;
      },
      submitHandle() {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            const api = this.detail
              ? '/financial/statistic/overdue/updateOther'
              : '/financial/statistic/overdue/saveOther';
            this.loading.startLoading();
            this.$axios.post(api, this.formatData(this.query)).then(({ data }) => {
              this.loading.endLoading();
              if (data.code === 0) {
                this.$message.success('添加成功');
                this.$emit('update:visible', false);
                this.$emit('refresh');
              }
            });
          }
        });
      },
      // 表单中的数据切换
      async changeMethod({ prop, val }) {
        console.log(prop, val, '修改');
        let isClear = false;
        if (val.length && Object.keys(val[0]).length == 1) {
          isClear = true;
        }
        if (prop == 'projectInitiationNo') {
          if (isClear) {
            this.query.contractNo = null;
            this.query.contractName = null;
            this.query.customerName = null;
            this.query.customerNo = null;
            this.query.contractBusinessCompanyName = null;
            this.query.contractBusinessCompanyNo = null;
            this.query.contractBusinessDepartmentName = null;
            this.query.contractBusinessDepartmentNo = null;
            this.query.platformCompanyCode = null;
            this.query.platformCompanyName = null;
            return;
          }
          this.query.projectInitiationNo = val[0].projectInitiationNo;
          this.query.projectName = val[0].projectName;
        } else if (prop == 'customerNo') {
          console.log('val', val);
          let item = val[0];
          if (item) {
            this.query.customerNo = item.partnerCode;
          }
        } else if (prop == 'contractNo') {
          console.log('val', val);
          if (isClear) return;
          let item = val[0];
          if (item) {
            this.query.contractNo = item.contractNo;
            this.query.contractName = item.contractName;
            this.query.customerName = item.customerName;
            this.query.customerNo = item.customerNo;
            this.query.contractBusinessCompanyName = item.contractBusinessCompanyName;
            this.query.contractBusinessCompanyNo = item.contractBusinessCompanyNo;
            this.query.contractBusinessDepartmentName = item.contractBusinessDepartmentName;
            this.query.contractBusinessDepartmentNo = item.contractBusinessDepartment;
            this.query.platformCompanyCode = item.platformCompanyCode;
            this.query.platformCompanyName = item.platformCompanyName;
          }
        } else if (prop == 'platformCompanyCode') {
          this.query.contractBusinessDepartment = null;
          if (val) {
            this.getDepartment(val);
          } else {
            this.departmentList = [];
          }
        }
      },
      async getDepartment(companyCode) {
        const allDepartment = this.userInfo?.allDepartmentList || [];
        this.departmentList = allDepartment
          .filter((v) => v.personCompanyCode == companyCode) //通过公司code过滤部门
          .map((v) => {
            return {
              value: v.personDepartmentCode,
              label: v.personDepartmentName,
            };
          });
      },
    },
  };
</script>
